import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { ScreenResponsive, SimulationValueCard } from "../../components";
import {
	Box,
	ButtonLayout,
	ButtonLink,
	ButtonSecondary,
	Grid,
	Text3,
	Text6,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import { strings } from "../../localization";
import { useNavigateCustom } from "../../hooks";

const CallCenter: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { title, description, card } = strings.pages.callCenter;
	const { back, toGoOut, callCenter } = strings.components.buttons;

	const onHandleToGoOut = useCallback(() => {
		navigation(-1);
	}, []);

	return (
		<ScreenResponsive navigationTitle={callCenter} onBack={onHandleToGoOut} isFullHeight>
			<Grid columns={1} justifyItems="center">
				<Box paddingBottom={isDesktopOrBigger ? 40 : 24} paddingTop={32}>
					<Grid columns={{ maxSize: 600 }}>
						<Text6>{title}</Text6>
						<Box padding={4} />
						<Text3 light color={"#666666"}>
							{description}
						</Text3>
					</Grid>
				</Box>
				<Grid justifyItems="center" columns={{ maxSize: 392 }}>
					<SimulationValueCard title={card.title} value={card.value} helperText={card.helperText} />
				</Grid>
			</Grid>
			<Box paddingTop={40}>
				{isDesktopOrBigger ? (
					<ButtonLayout align={"center"}>
						<ButtonLink onPress={onHandleToGoOut}>{toGoOut}</ButtonLink>
					</ButtonLayout>
				) : (
					<ButtonSecondary style={{ width: "auto" }} onPress={onHandleToGoOut}>
						<Text3 medium color={skinVars.colors.textButtonSecondary}>
							{back}
						</Text3>
					</ButtonSecondary>
				)}
			</Box>
		</ScreenResponsive>
	);
});

export default CallCenter;
